import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import LocationLayer from "../components/LocationLayer";

const LocationPage = () => {
    return (
        <MasterLayout>
            <LocationLayer />
        </MasterLayout>
    );
};

export default LocationPage;
